import styled from 'styled-components'

export const Wrap = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 3vw;
`
